export interface PaymentMethodGetDto {
  hasPaymentSource: boolean;
  paymentIntent?: unknown;
}

export interface PaymentChargebeeSsoSessionUrlGetDto {
  url: string;
}
